<!-- <footer class="footer"> -->
<!-- <div class="container"> -->
<!-- <a routerLink="/" *ngIf="logo_url"> -->
<!-- <img [src]="logo_url?.url" [width]="100"> -->
<!-- </a> -->
<!-- </div> -->
<!-- </footer> -->
<footer></footer>
